import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=17ee3b82&scoped=true"
import script from "./RegionList.vue?vue&type=script&lang=js"
export * from "./RegionList.vue?vue&type=script&lang=js"
import style0 from "./RegionList.vue?vue&type=style&index=0&id=17ee3b82&prod&lang=scss"
import style1 from "./RegionList.vue?vue&type=style&index=1&id=17ee3b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ee3b82",
  null
  
)

export default component.exports